module.exports = window.$;


//////////////////
// WEBPACK FOOTER
// external "window.$"
// module id = 0iPh
// module chunks = 15